/* WT Hero Carousel — autoplay, arrows, dots, swipe. No smooth-scroll APIs (theme gotcha). */
(function () {
  'use strict';

  function initCarousel(root) {
    if (root.dataset.wtInit === '1') return;
    root.dataset.wtInit = '1';

    var track = root.querySelector('[data-wt-track]');
    var slides = Array.prototype.slice.call(root.querySelectorAll('[data-wt-slide]'));
    var dotsWrap = root.querySelector('[data-wt-dots]');
    var prevBtn = root.querySelector('[data-wt-prev]');
    var nextBtn = root.querySelector('[data-wt-next]');
    if (!track || slides.length < 2) {
      if (prevBtn) prevBtn.style.display = 'none';
      if (nextBtn) nextBtn.style.display = 'none';
      return;
    }

    var dwell = parseInt(root.dataset.dwell, 10) || 6000;
    var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var index = 0;
    var timer = null;
    var paused = false;

    var dots = slides.map(function (_, i) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'wt-hc__dot';
      b.setAttribute('aria-label', 'Go to slide ' + (i + 1));
      b.addEventListener('click', function () { go(i, true); });
      dotsWrap.appendChild(b);
      return b;
    });

    function render() {
      track.style.transform = 'translateX(' + (-100 * index) + '%)';
      dots.forEach(function (d, i) {
        d.setAttribute('aria-current', i === index ? 'true' : 'false');
      });
    }

    function go(i, user) {
      index = (i + slides.length) % slides.length;
      render();
      if (user) restart();
    }

    function tick() { go(index + 1, false); }

    function start() {
      if (reduced || timer) return;
      timer = setInterval(function () { if (!paused) tick(); }, dwell);
    }
    function restart() {
      if (timer) { clearInterval(timer); timer = null; }
      start();
    }

    if (prevBtn) prevBtn.addEventListener('click', function () { go(index - 1, true); });
    if (nextBtn) nextBtn.addEventListener('click', function () { go(index + 1, true); });

    root.addEventListener('mouseenter', function () { paused = true; });
    root.addEventListener('mouseleave', function () { paused = false; });
    document.addEventListener('visibilitychange', function () { paused = document.hidden; });

    /* swipe */
    var startX = null;
    var startY = null;
    root.addEventListener('touchstart', function (e) {
      if (e.touches.length !== 1) return;
      startX = e.touches[0].clientX;
      startY = e.touches[0].clientY;
    }, { passive: true });
    root.addEventListener('touchend', function (e) {
      if (startX === null) return;
      var dx = e.changedTouches[0].clientX - startX;
      var dy = e.changedTouches[0].clientY - startY;
      startX = null; startY = null;
      if (Math.abs(dx) > 48 && Math.abs(dx) > Math.abs(dy) * 1.5) {
        go(index + (dx < 0 ? 1 : -1), true);
      }
    }, { passive: true });

    render();
    start();
  }

  function boot() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-wt-carousel]'), initCarousel);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  /* theme editor re-renders */
  document.addEventListener('shopify:section:load', boot);
})();
